import React from "react";
import ProjectImage from "../../resources/bE-More architecture_ita.png"

const Project = () => {
    return (
    <div className="page__section" id="project">
        <p className="title">Il Progetto</p>
        <hr></hr>
        <div className='project__content'>
        <div className='project__text'>
            <p className='project__text__cell'>
                Il progetto è basato sullo scambio di dati tra la piattaforma ThingsBoard e i sensori.
                Per accedervi vi sono il web o la nostra applicazione appositamente sviluppata.
                Tramite questa si può effettuare un'analisi dei dati raccolti grazie all'AI.
                Il sistema può applicare soluzioni in tempo reale.<br></br><br></br>
                <i><p className="project__important">[Il futuro aspetta grandi novità...]</p></i>
            </p>
        </div>
        <img className='project__image' src={ProjectImage}></img>
        </div>
    </div>
    );
};


export default Project;